





































import {Component, Prop} from "vue-property-decorator";
import Vue from "vue";
import {CurrentTournamentStoreModule, PopupsStoreModule} from "@/store";
import {ITournamentEntity} from "@/core/tournaments/tournament.entity";
import {Getter} from "vuex-class";
import {StoreNamespace} from "@/store/types";
import {AccountGameAccountsModuleGetterTypes} from "@/store/modules/account/gameAccounts/types";
import {IGameAccountEntity} from "@/core/accounts/game-accounts/game-account.entity";
import {ITournamentJoinRequest} from "@/services/account/tournament.types";
import {accountService} from "@/services";
import {NotificationService} from "@/components/Notifications/notification.service";
import {ValidationObserver, ValidationProvider} from "vee-validate/dist/vee-validate.full";
import {RouteNames} from "@/router/types";

export interface ITournamentJoinPopupData {
  tournament: ITournamentEntity
  withRedirect: boolean
}

@Component({
  components: {ValidationObserver, ValidationProvider}
})
export default class TournamentJoinPopup extends Vue {
  @Prop({ type: Boolean, required: true, default: () => false }) private readonly isActive!: boolean
  @Prop({ type: Object, required: true, default: () => {} }) private readonly data!: ITournamentJoinPopupData

  @Getter(AccountGameAccountsModuleGetterTypes.GAME_ACCOUNTS, { namespace: StoreNamespace.AccountGameAccounts })
  private readonly gameAccounts!: IGameAccountEntity[]

  private isLoading: boolean = false
  private isProcessing: boolean = false
  private formObserver: InstanceType<typeof ValidationObserver> | null = null
  private form: ITournamentJoinRequest = {
    my_game_account_id: undefined
  }

  private mounted () {
    if (this.$refs.tournamentJoinValidationObserver) {
      this.formObserver = this.$refs.tournamentJoinValidationObserver as InstanceType<typeof ValidationObserver>
    }
    this.setDefaultGameAccount()
  }

  get tournament (): ITournamentEntity | null {
    if (this.data.tournament) {
      return this.data.tournament
    }
    return null
  }

  private setDefaultGameAccount () {
    if (this.gameAccounts.length > 0) {
      this.form.my_game_account_id = this.gameAccounts[0].id
    }
  }

  private async onJoinAction () {
    if (this.tournament === null) return

    this.isLoading = true
    this.isProcessing = true
    const joinToTournamentResult = await accountService.joinParticipantToTournament(this.tournament.id, this.form)

    if (joinToTournamentResult.isFailure()) {
      NotificationService.showErrorNotification(joinToTournamentResult.error.message)
      this.isLoading = false
      this.isProcessing = false
    } else {
      NotificationService.showSuccessNotification('Successfully joined to tournament')
      this.isLoading = false
      if (this.data.withRedirect) {
        await this.$router.push({ name: RouteNames.TournamentRoute, params: { tournamentId: this.tournament.id.toString() } })
      } else {
        await CurrentTournamentStoreModule.refreshCurrentTournamentParticipants()
      }
      await PopupsStoreModule.hideActivePopup()
    }
  }

  private onCloseAction () {
    PopupsStoreModule.hideActivePopup()
  }
}
